import React, { useCallback } from 'react';
import { DialogSettingsTool } from 'components/ai/tools/DialogSettingsTool';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';

import RestartButton from '../RestartButton';


const DialogSettings = (props) => {
  const {
    sending,
    handleCheckMessageOnBlockers,
    setIsResetDialogModalOpen,
    setChangeNameModal,
    setSubscriptionModalState,
    setIsSignUpModalOpen
  } = props;


  const { currentUser, hasSubscription } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);
      const hasSubscription = currentUser?.hasSubscription == true;
      return {
        currentUser: state.users.usersMap.get(state.users.currentUserId),
        hasSubscription: hasSubscription
      };
    }, [])
  );

  const handleRestartClick = () => {
    if (handleCheckMessageOnBlockers('reset_dialog_button_click')) {
      return;
    }
    setIsResetDialogModalOpen(true);
  };

  return (
    <SettingsPlaceholder>
      <RestartButton sending={sending} handleRestartClick={handleRestartClick} />
      <DialogSettingsTool
        currentUser={currentUser}
        hasSubscription={hasSubscription}
        onChangeName={() => setChangeNameModal(true)}
        onPremiumClick={() =>
          setSubscriptionModalState({
            isOpen: true,
            renderedForReason: 'dialog_settings_click'
          })
        }
        onAuthClick={() => setIsSignUpModalOpen(true)}
      />
    </SettingsPlaceholder>
  );
};

export default DialogSettings;

const SettingsPlaceholder = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;

  display: flex;
  flex-direction: row;
  gap: 8px;
  @media (max-width: 720px) {
    display: none;
  }
`;
